var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "evm_tx_data_table"
    }
  }, [_vm.title ? _c('v-card-title', [_vm._v(" " + _vm._s(_vm.title) + " "), _c('v-spacer')], 1) : _vm._e(), _c('v-data-table', {
    attrs: {
      "items": _vm.transactions,
      "headers": _vm.headers,
      "multi-sort": "",
      "mobile-breakpoint": 0
    },
    scopedSlots: _vm._u([{
      key: "item.type",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_vm._v(_vm._s(item.type))];
      }
    }, {
      key: "item.hash",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c('div', [_c('router-link', {
          staticClass: "id_overflow",
          attrs: {
            "to": "/evmtx/".concat(item.hash)
          }
        }, [_vm._v(_vm._s(item.hash))])], 1)];
      }
    }, {
      key: "item.v",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c('div', [_c('router-link', {
          staticClass: "id_overflow",
          attrs: {
            "to": "/evmaddress/".concat(item.v)
          }
        }, [_vm._v(_vm._s(item.v))])], 1)];
      }
    }, {
      key: "item.value",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_c('div', [_vm._v(_vm._s(item.value) + " AVAX")])];
      }
    }, {
      key: "item.input",
      fn: function fn(_ref5) {
        var item = _ref5.item;
        return [_c('div', [_c('span', {
          staticClass: "id_overflow"
        }, [_vm._v(_vm._s(item.input))])])];
      }
    }, {
      key: "item.to",
      fn: function fn(_ref6) {
        var item = _ref6.item;
        return [_c('div', [_c('router-link', {
          staticClass: "id_overflow",
          attrs: {
            "to": "/evmaddress/".concat(item.to)
          }
        }, [_vm._v(_vm._s(item.to))])], 1)];
      }
    }, {
      key: "item.gasPrice",
      fn: function fn(_ref7) {
        var item = _ref7.item;
        return [_c('div', [_vm._v(_vm._s(item.gasPrice) + " AVAX")])];
      }
    }, {
      key: "item.gas",
      fn: function fn(_ref8) {
        var item = _ref8.item;
        return [_c('div', [_vm._v(_vm._s(item.gas.toLocaleString()))])];
      }
    }])
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }